export default "__VITE_ASSET__BwFJfBzY__"